<template>
  <div>
    <div v-bind:class="!record.active ? 'close': ''">
      <div class="record-head pointer">
        <div class="record-left">
          <span  @click="goToDetail" class="chatclass" v-bind:class="record.data.TradeType == 1 ? 'up':'down'">
            <v-icon class="sajz" v-bind:class="record.data.TradeType == 1 ? 'up':'down'">{{symbol}}</v-icon>
            <b>
              <span v-if="record.data.TradeType == 1">Long Trade</span>
              <span v-else>Short Trade</span>
            </b>
          </span>
          <span class="text-grey">
            |
            <span @click="emitUser(record.user.username)" class="user-name">{{record.user.username}}</span>
            |
            <span  @click="goToDetail">{{openTime}}</span>
            <v-tooltip v-if="record.data._prepare" bottom>
              <template v-slot:activator="{ on }">
                <v-icon  @click="goToDetail" v-on="on" size="18" color="#4dbac0" class="mr-1">hourglass_empty</v-icon>
              </template>
              <span  @click="goToDetail">prepared trade</span>
            </v-tooltip>

            <v-tooltip v-if="record.data._entryLevel" bottom>
              <template v-slot:activator="{ on }">
                <v-icon  @click="goToDetail" v-on="on" size="18" color="#4dbac0" class="mr-1">calendar_view_day</v-icon>
              </template>
              <span  @click="goToDetail">trade in zone</span>
            </v-tooltip>
          </span>
          <div  @click="goToDetail" class="record-body ml-5">
            <div>
              <b>{{record.data.Symbol.user}}</b>
              |
              {{Math.abs(record.data.EntryQuantity)}}
              <span v-if="Math.abs(record.data.EntryQuantity) > 1">pcs</span>
              <span v-else>pc</span>
              |
              Price:
              {{record.data.AverageEntryPrice.toFixed(2)}}
              |
              Result:
              <v-btn
                x-small
                v-bind:color="record.data.OpenProfitLoss > 0 ? '#79C04D': (record.data.OpenProfitLoss < 0 ?'#E62163' : '#808F9C')"
              >${{record.data.OpenProfitLoss.toFixed(2)}}</v-btn>
            </div>
          </div>
        </div>
      </div>
      <div class="record-right">
        <span @click="routeUser()" class="pointer hover">
          <Avatar
            v-if="record.user.avatar != null"
            class="timeline-avatar"
            :src="`https://tradeinpool.com/upload/${record.user.avatar}.png`"
            :size="40"
          ></Avatar>
          <Avatar v-else class="timeline-avatar" :username="record.user.username" :size="40"></Avatar>
        </span>
        <div class="record-menu">
          <MenuCard :record="record" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import MenuCard from "@/components/menuCard";
var moment = require("moment-timezone");
export default {
  components: {
    Avatar,
    MenuCard
  },
  props: ["record"],
  data() {
    return {
      type: "",
      symbol: "",
      mainClass: "",
      fromNow: moment
        .tz(this.record.created, this.$store.getters.timezone)
        .fromNow()
    };
  },
  methods: {
    emitUser(user){
      this.$emit("emitUser",user)
    },
    goToDetail() {
      return this.$router.push({
        path:
          "/trades/" +
          this.record.user.username +
          "/" +
          this.record.data.openTimestamp
      });
    },
    routeUser() {
      return this.$router.push({ path: "/user/" + this.record.user.username });
    },
    replyName(val) {
      this.$emit("reply_to", val);
    }
  },
  mounted() {
    if (this.record.data.TradeType == 1) {
      this.symbol = "trending_up";
    } else {
      this.symbol = "trending_down";
    }
    // updating record time
  },

  computed: {
    openTime() {
      var value = this.record.created;
      var a = moment.tz(value, this.$store.getters.timezone).startOf("day");
      var b = moment
        .tz(new Date(), this.$store.getters.timezone)
        .startOf("day");
      var diff = a.diff(b, "days"); // =1
      if (diff == 0)
        return (
          "Today | " +
          moment.tz(value, this.$store.getters.timezone).format("HH:mm")
        );
      else if (diff == -1)
        return (
          "Yesterday | " +
          moment.tz(value, this.$store.getters.timezone).format("HH:mm")
        );
      else
        return moment
          .tz(value, this.$store.getters.timezone)
          .format("YYYY-MM-DD | HH:mm");
    },

    qtyReturned() {
      if (this.record.Quantity) return this.record.Quantity;
      else return this.record.EntryQuantity;
    }
  }
};
</script>

<style scoped>
.sajz {
  font-size: 18px;
  margin-bottom: 3px;
  margin-right: 2px;
}

.down,
.errors {
  color: #e62163;
}

.up,
.successes {
  color: #79c04d;
}

.close {
  opacity: 0.4;
}
</style>
